import CatHero from './Cat_Hero.png';
import DogHero from './Dog_Hero.png';
import PetHero from './Pet_Hero.png';

export { default as dogTrainingHeroImage } from './Dog_Training_Hero.png';
export { default as dogWalkingHeroImage } from './Dog_Walking_Hero.png';
export { default as quickFactBackgroundDoodle } from './quick-fact-background-doodle.svg?url';

// Boarding, drop-in, and house-sitting each render one of three pet-type variants; the
// underlying art is shared across all three service types per pet type (a cat, dog, or
// pet-agnostic photo), so each group of exports below intentionally points at the same file.
export const boardingCatHeroImage = CatHero;
export const dropInCatHeroImage = CatHero;
export const houseSittingCatHeroImage = CatHero;

export const boardingDogHeroImage = DogHero;
export const doggyDayCareHeroImage = DogHero;
export const dropInDogHeroImage = DogHero;
export const houseSittingDogHeroImage = DogHero;

export const boardingPetHeroImage = PetHero;
export const dropInPetHeroImage = PetHero;
export const houseSittingPetHeroImage = PetHero;
